import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnChanges,
	SimpleChanges,
} from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { ReportSummary } from "src/app/models/models";
import { PfPmReportLayoutKey } from "../../report-summary-layout.types";
import {
	Ts1ReportPreviewContext,
	buildTs1ReportPreviewContext,
	isTs1PfPmReportSummary,
} from "../../ts1-report-preview.utils";

@Component({
	selector: "app-ts1-pfpm-report-layout",
	templateUrl: "./ts1-pfpm-report-layout.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class Ts1PfpmReportLayoutComponent implements OnChanges {
	@Input() layoutKey: PfPmReportLayoutKey = "ts1-pfpm-v3";
	@Input() reportSummary?: ReportSummary;
	@Input() candidateId = "";

	pageIndex = 0;
	previewContext: Ts1ReportPreviewContext | null = null;

	constructor(private readonly fb: UntypedFormBuilder) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["reportSummary"] || changes["candidateId"]) {
			this.pageIndex = 0;
			this.rebuildPreviewContext();
		}
	}

	get hasManeuverBreakdown(): boolean {
		return (this.reportSummary?.ts1V3PreviewSummary?.maneuverBreakdownView?.length ?? 0) > 0;
	}

	get showNextButton(): boolean {
		return this.pageIndex === 0 && this.hasManeuverBreakdown;
	}

	get isV4Layout(): boolean {
		return this.layoutKey === "ts1-pfpm-v4";
	}

	private rebuildPreviewContext(): void {
		if (!this.reportSummary || !this.candidateId || !isTs1PfPmReportSummary(this.reportSummary)) {
			this.previewContext = null;
			return;
		}

		this.previewContext = buildTs1ReportPreviewContext(this.reportSummary, this.fb, this.candidateId);
	}
}
